(function ($) {

    let initNav = function () {
        $('#search-icon').on('click', function () {
            $(this).toggleClass('is-active');
            $('.searchfield').toggleClass('is-active');
        });
    }

    $(document).ready(function () {
        initNav();
        $('html').removeClass('no-js');
        //alert("Yeah!");
    });

})(jQuery);